import classNames from 'classnames';
import { ReactNode } from 'react';
import styled, { CSSProperties } from 'styled-components';

import {
  Box,
  BoxProps,
  hoverStyle,
  selectedStyle,
} from '@sorare/core/src/atoms/ui/Box';
import {
  ensureHexColor,
  getTextColorFromBackgroundColor,
} from '@sorare/core/src/lib/colors';

import lightningBg from './assets/lightning-bg.svg';

const Wrapper = styled(Box)`
  align-items: center;
  justify-content: center;
  padding: 0;
  overflow: hidden;
  background: var(--c-nd-50);

  &.withLightning {
    background:
      center / cover url(${lightningBg}),
      var(--c-nd-50);
  }

  &.selectable:hover,
  &.selectable:focus {
    cursor: pointer;
    ${hoverStyle}
  }
  &.selected {
    ${selectedStyle}
  }
  &.color {
    background:
      center / cover url(${lightningBg}),
      linear-gradient(to right, var(--lightning-color), var(--lightning-color));
  }
  &.locked {
    border: 1px solid var(--c-black);
  }
  &.transparent {
    background: transparent;
  }
`;

type Props = {
  children: ReactNode;
  withLightning?: boolean;
  transparent?: boolean;
  lightningColor?: string | null;
} & BoxProps;

export const GameWrapper = ({
  children,
  withLightning,
  transparent,
  lightningColor,
  className,
  ...rest
}: Props) => {
  const color = lightningColor
    ? getTextColorFromBackgroundColor(ensureHexColor(lightningColor))
    : 'var(--c-white)';

  return (
    <Wrapper
      {...rest}
      className={classNames(className, {
        transparent,
        withLightning,
        color: !!lightningColor,
      })}
      style={
        lightningColor
          ? ({
              '--lightning-color': lightningColor,
              color,
            } as CSSProperties)
          : undefined
      }
    >
      {children}
    </Wrapper>
  );
};
